import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppNotificationService } from '../../services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.css'],
})
export class NotificationBannerComponent implements OnInit, OnDestroy {
  showBanner: boolean;
  genericSystemMessage: string;
  subscription: Subscription;

  constructor(private appNotificationService: AppNotificationService) {}

  ngOnInit(): void {
    this.subscription = this.appNotificationService.getAppMessages().subscribe(
      (msg) => {
        this.genericSystemMessage = msg || '';
        this.showBanner = !!this.genericSystemMessage;
      },
      (err) => {
        console.log('Err: ' + err);
        this.showBanner = false;
      },
      () => {},
    );
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
